/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
/* eslint-disable import/prefer-default-export */
// eslint-disable-next-line import/no-extraneous-dependencies
import axios from 'axios';
import moment from 'moment';

async function getAllCourses() {
  const start = new Date();
  start.setYear(start.getYear() - 1);
  // const end = new Date('2024-01-01').toISOString();
  try {
    const res = await axios({
      method: 'get',
      url: `https://ext.edusign.fr/v1/course?start=${start}`,
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
    });
    return res.data.result;
  } catch (err) {
    return err.response;
  }
}

async function getGroupCourses(start) {
  // const end = new Date(coursePlanDates.end).toISOString();
  try {
    const res = await axios({
      method: 'get',
      url: `https://ext.edusign.fr/v1/course?start=${start}`,
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
    });
    return res.data.result;
  } catch (err) {
    return err.response;
  }
}

async function getCoursesByStudentId(studentId) {
  // const end = new Date(coursePlanDates.end).toISOString();
  try {
    const res = await axios({
      method: 'get',
      url: `https://ext.edusign.fr/v1/course?studentId=${studentId}`,
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
    });
    return res.data.result;
  } catch (err) {
    return err.response;
  }
}

async function getCoursesByProfessorId(professorId) {
  // const end = new Date(coursePlanDates.end).toISOString();
  try {
    const res = await axios({
      method: 'get',
      url: `https://ext.edusign.fr/v1/course?professorId=${professorId}`,
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
    });
    return res.data.result;
  } catch (err) {
    return err.response;
  }
}

async function getCoursesByCourseName(courseName) {
  try {
    const res = await axios({
      method: 'get',
      url: `https://ext.edusign.fr/v1/course?courseName=${courseName}`,
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
    });
    const finalCoursesArr = [];
    if (res.data.result && res.data.result.length > 0) {
      res.data.result.forEach((course) => {
        if (course.NAME.includes(courseName)) {
          finalCoursesArr.push(course);
        }
      });
    }
    return finalCoursesArr;
  } catch (err) {
    return err.response;
  }
}

async function getSchoolData() {
  try {
    const res = await axios({
      method: 'get',
      url: 'https://ext.edusign.fr/v1/school',
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
    });
    return res.data.result;
  } catch (err) {
    return err.response;
  }
}

async function getDailyCourses() {
  try {
    const res = await axios({
      method: 'get',
      url: 'https://ext.edusign.fr/v1/school/daily-courses/a999kirxhy6lxtt',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return res.data.result;
  } catch (err) {
    return err.response;
  }
}

async function getTeacher(email) {
  try {
    const res = await axios({
      method: 'get',
      url: `https://ext.edusign.fr/v1/professor/by-email/${email}`,
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
    });
    return res.data.result;
  } catch (err) {
    return err.response;
  }
}

async function getTeacherById(id) {
  try {
    const res = await axios({
      method: 'get',
      url: `https://ext.edusign.fr/v1/professor/${id}`,
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
    });
    return res.data.result;
  } catch (err) {
    return err.response;
  }
}

async function getStudent(email) {
  try {
    const res = await axios({
      method: 'get',
      url: `https://ext.edusign.fr/v1/student/by-email/${email}`,
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
    });
    return res.data.result;
  } catch (err) {
    return err.response;
  }
}

async function getStudentById(id) {
  try {
    const res = await axios({
      method: 'get',
      url: `https://ext.edusign.fr/v1/student/${id}`,
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
    });
    return res.data.result;
  } catch (err) {
    return err.response;
  }
}

async function getStudentPresenceSummary(id, start, end) {
  // const start = new Date('01 January 2023 00:00 UTC').toISOString();
  // const end = new Date('30 December 2023 00:00 UTC').toISOString();
  try {
    const res = await axios({
      method: 'post',
      url: `https://ext.edusign.fr/v1/student/hours-of-presence/${id}`,
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
      data: {
        start: moment(new Date(start)).format('YYYY-MM-DD HH:mm:ss'),
        end: moment(new Date(end)).format('YYYY-MM-DD HH:mm:ss'),
      },
    });
    return res.data.result;
  } catch (err) {
    return err.response;
  }
}

async function getSignatureLinks(courseId) {
  try {
    const res = await axios({
      method: 'get',
      url: `https://ext.edusign.fr/v1/course/get-signature-links/${courseId}`,
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
    });
    return res.data.result;
  } catch (err) {
    return err.response;
  }
}

async function getTeacherSignatureLink(courseId) {
  try {
    const res = await axios({
      method: 'get',
      url: `https://ext.edusign.fr/v1/course/get-professors-signature-links/${courseId}`,
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
    });
    return res.data.result;
  } catch (err) {
    return err.response;
  }
}

async function sendSignatureEmails(courseObj) {
  try {
    const res = await axios({
      method: 'post',
      url: 'https://ext.edusign.fr/v1/course/send-sign-emails',
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
      data: {
        course: courseObj.courseId,
        students: courseObj.students,
      },
    });
    return res.data.result;
  } catch (err) {
    return err.response;
  }
}

async function sendJustifiedAbsence(absenceObj) {
  try {
    const res = await axios({
      method: 'post',
      url: 'https://ext.edusign.fr/v1/justified-absence',
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
      data: {
        STUDENT_ID: absenceObj.studentId,
        COURSE_ID: absenceObj.courseId,
        TYPE: absenceObj.absenceReason,
        COMMENT: absenceObj.absenceComment,
      },
    });
    return res.data.result;
  } catch (err) {
    return err.response;
  }
}

async function getCourseById(courseId) {
  try {
    const res = await axios({
      method: 'get',
      url: `https://ext.edusign.fr/v1/course/${courseId}`,
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
    });
    return res.data.result;
  } catch (err) {
    return err.response;
  }
}

async function exportSummary(dataObj) {
  try {
    const res = await axios({
      method: 'post',
      url: `https://ext.edusign.fr/v1/course/getGroupAttendanceSheet/${dataObj.groupId}`,
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
      data: {
        PROFESSOR_ID: dataObj.professorId,
        DATE_START: dataObj.courseStart,
        DATE_END: dataObj.courseEnd,
      },
    });
    return res.data.result;
  } catch (err) {
    return err.response;
  }
}

async function exportStudentPresenceSummaryDoc(dataObj) {
  try {
    const res = await axios({
      method: 'post',
      url: 'https://ext.edusign.fr/v1/document/student/courses-between-dates',
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
      data: {
        STUDENT_ID: dataObj.studentId,
        DATE_START: dataObj.courseStart,
        DATE_END: dataObj.courseEnd,
      },
    });
    return res.data.result;
  } catch (err) {
    return err.response;
  }
}

async function exportTeacherPresenceSummaryDoc(dataObj) {
  try {
    const res = await axios({
      method: 'post',
      url: 'https://ext.edusign.fr/v1/document/professor/courses-between-dates',
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
      data: {
        PROFESSOR_ID: dataObj.professorId,
        DATE_START: dataObj.courseStart,
        DATE_END: dataObj.courseEnd,
      },
    });
    return res.data;
  } catch (err) {
    return err.response;
  }
}

async function createSurvey(dataObj) {
  try {
    const res = await axios({
      method: 'post',
      url: 'https://ext.edusign.fr/v1/surveys',
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
      data: {
        survey: dataObj.surveyTemplateId,
        students: dataObj.students,
        professors: dataObj.professors,
        sending_date: dataObj.sendingDate,
      },
    });
    return res.data;
  } catch (err) {
    return err.response;
  }
}

async function getSurveys() {
  try {
    const res = await axios({
      method: 'get',
      url: 'https://ext.edusign.fr/v1/surveys',
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
    });
    return res.data;
  } catch (err) {
    return err.response;
  }
}

async function getSurveyById(surveyId) {
  try {
    const res = await axios({
      method: 'get',
      url: `https://ext.edusign.fr/v1/surveys/${surveyId}`,
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
    });
    return res.data;
  } catch (err) {
    return err.response;
  }
}

async function getAbsences() {
  try {
    const res = await axios({
      method: 'get',
      url: 'https://ext.edusign.fr/v1/justified-absence/absence-reason',
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
    });
    return res.data;
  } catch (err) {
    return err.response;
  }
}

async function createAbsence(dataObj) {
  try {
    const res = await axios({
      method: 'post',
      url: 'https://ext.edusign.fr/v1/justified-absence/absence-reason',
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
      data: {
        NAME: dataObj.NAME,
        ID: dataObj.ID,
      },
    });
    return res.data;
  } catch (err) {
    return err.response;
  }
}

async function archiveAbsence(absenceId) {
  try {
    const res = await axios({
      method: 'delete',
      url: 'https://ext.edusign.fr/v1/justified-absence/absence-reason',
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_EDUSIGN_TOKEN}`,
        'Content-Type': 'application/json',
      },
      data: {
        ID: absenceId,
      },
    });
    return res.data;
  } catch (err) {
    return err.response;
  }
}

export const edusignServices = {
  getAllCourses,
  getGroupCourses,
  getSchoolData,
  getDailyCourses,
  getTeacher,
  getTeacherById,
  getStudent,
  getStudentById,
  getCoursesByCourseName,
  getStudentPresenceSummary,
  getSignatureLinks,
  getTeacherSignatureLink,
  sendSignatureEmails,
  sendJustifiedAbsence,
  getCourseById,
  exportSummary,
  exportStudentPresenceSummaryDoc,
  exportTeacherPresenceSummaryDoc,
  createSurvey,
  getSurveys,
  getSurveyById,
  getCoursesByStudentId,
  getCoursesByProfessorId,
  getAbsences,
  createAbsence,
  archiveAbsence,
};
